import { useEffect, useState, useCallback } from 'react'
import { initLiff, isLoggedIn, loginWithLine, getLiffProfile } from '../lib/liff'
import { api } from '../lib/api'
import { useAppStore } from '../store/useAppStore'

export function useLiffAuth() {
  const { lineUid, setLineUid, setProfile } = useAppStore()
  const [ready, setReady] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refreshProfile = useCallback(async (uid: string) => {
    try {
      const profile = await api.user.profile(uid) as Parameters<typeof setProfile>[0]
      setProfile(profile)
    } catch (err) {
      console.warn('[useLiffAuth] Profile refresh failed', err)
    }
  }, [setProfile])

  useEffect(() => {
    async function init() {
      try {
        await initLiff()

        if (!import.meta.env.VITE_LIFF_ID) {
          setLineUid('dev-user-001')
          setReady(true)
          return
        }

        if (!isLoggedIn()) {
          loginWithLine()
          return
        }

        const lineProfile = await getLiffProfile()
        if (!lineProfile) throw new Error('Cannot get LINE profile')

        const uid = lineProfile.userId

        await api.user.upsert(uid, lineProfile.displayName, lineProfile.pictureUrl)

        const profile = await api.user.profile(uid) as Parameters<typeof setProfile>[0]
        setLineUid(uid)
        setProfile(profile)
        setReady(true)
      } catch (err) {
        console.error('[useLiffAuth]', err)
        setError(err instanceof Error ? err.message : 'Login failed')
        setReady(true)
      }
    }

    init()
  }, [setLineUid, setProfile])

  return { ready, error, lineUid, refreshProfile }
}
